import { Reveal, SectionHeader } from "./Reveal";
import PhotoFrame from "./PhotoFrame";
import { waLink } from "../lib/site";

const OCCASIONS = [
    "Formaturas",
    "Aniversários",
    "Casamentos",
    "Turmas",
    "Homenagens",
    "Eventos",
];

export default function Events() {
    return (
        <section id="eventos" className="bg-paper py-20 sm:py-28 lg:py-32">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-14 items-center">
                <div className="lg:col-span-5 order-2 lg:order-1">
                    <Reveal delay={0.15} className="relative">
                        <PhotoFrame
                            label="Eventos e formaturas — foto real em breve"
                            ratio="aspect-[4/5]"
                            testId="events-frame"
                        />
                    </Reveal>
                </div>

                <div className="lg:col-span-7 order-1 lg:order-2">
                    <SectionHeader
                        eyebrow="Para eventos"
                        title={
                            <>
                                Seu evento merece
                                <br />
                                <span className="italic text-gold-deep">uma lembrança especial</span>
                            </>
                        }
                        sub="Personalizamos produtos para formaturas, aniversários, casamentos, turmas, eventos, homenagens e diversas ocasiões especiais."
                    />

                    <Reveal delay={0.2}>
                        <div className="flex flex-wrap gap-2.5 mt-9">
                            {OCCASIONS.map((o) => (
                                <span
                                    key={o}
                                    data-testid={`event-chip-${o.toLowerCase()}`}
                                    className="font-body text-xs text-ink/80 border border-ink/15 rounded-full px-4 py-2 hover:border-gold hover:text-gold-deep transition-colors"
                                >
                                    {o}
                                </span>
                            ))}
                        </div>
                    </Reveal>

                    <Reveal delay={0.28}>
                        <button
                            data-testid="events-cta"
                            onClick={() =>
                                window.open(
                                    waLink(
                                        "Olá! Vim pelo site da Magnus e quero um orçamento para o meu evento.",
                                    ),
                                    "_blank",
                                )
                            }
                            className="mt-10 border border-ink/25 text-ink font-body text-xs sm:text-sm font-semibold uppercase tracking-[0.16em] px-8 py-4 rounded-full hover:border-gold hover:text-gold-deep transition-all duration-300"
                        >
                            Fazer orçamento para meu evento
                        </button>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
